import { Params, useParams } from "react-router-dom";
import { isTaskDMP } from "tm-shared/utils";

import { useAppSelector } from "@/hooks/redux";
import NotFound from "@/routes/Pages/NotFound";

import { DMPPage } from "./DMPPage";

interface DMPParams extends Params {
    marketId: string;
    taskId: string;
}

const DMP = () => {
    const { marketId, taskId } = useParams<DMPParams>();
    const { markets, tasks } = useAppSelector((s) => s.work);

    const safeMarketId = marketId ?? "";
    const safeTaskId = taskId ?? "";

    const currentMarket = markets?.[safeMarketId];
    const currentTask = tasks?.[safeMarketId]?.[safeTaskId];

    if (!currentMarket || !currentTask || !isTaskDMP(currentTask)) {
        return <NotFound />;
    }

    return <DMPPage task={currentTask} market={currentMarket} />;
};

export default DMP;
